module.exports = __webpack_public_path__ + "img/biodiversity11.a0fca285.png";